import { createAction, props, union } from '@ngrx/store';
import { InfLocationHistoryQueryI } from 'src/app/api/inf-location-history/inf-location-history.query.int';
import { InfLocationHistoryI } from 'src/app/api/inf-location-history/inf-location-history.result.int';

export const error = createAction('[INF / Location History] Error', props<{ messageText: string }>());
export const load = createAction('[INF / Location History] Get', props<{
    query: InfLocationHistoryQueryI;
}>());
export const received = createAction('[INF / Location History] Received', props<{
    result: InfLocationHistoryI;
}>());
export const reset = createAction('[INF / Location History] Reset', props<Record<string, unknown>>());

const all = union({
    error,
    load,
    received,
    reset,
});
export type Actions = typeof all;
